// Lib
import { Action } from 'redux';

// Constants
import * as ACTIONS from './actionTypes';
import { SearchResults, Connect } from './types';

export const cleanState = () => ({
    type: ACTIONS.CLEAN_STATE
});

export const cleanSearchResults = () => ({
    type: ACTIONS.CLEAN_SEARCHRESULTS
});

export interface ActionSearchByIDAPI extends Action {
    iddealer?: string
}

export const searchByIDAPI = (iddealer?: string): ActionSearchByIDAPI => ({
    type: ACTIONS.SEARCHING_BY_ID_API_REQUEST,
    iddealer
});

export interface ActionSearchByIDAPISuccess extends Action {
    searchResults: SearchResults,
}

export const searchByIDAPISuccess = (searchResults: SearchResults): ActionSearchByIDAPISuccess => ({
    type: ACTIONS.SEARCHING_BY_ID_API_SUCCESS,
    searchResults
});

export const searchByIDAPIError = (): Action => ({
    type: ACTIONS.SEARCHING_BY_ID_API_ERROR,
});

export interface ActionSearchByLabelAPI extends Action {
    iddealer: string,
    label?: string
}

export const searchByLabelAPI = (iddealer: string, label?: string): ActionSearchByLabelAPI => ({
    type: ACTIONS.SEARCHING_BY_LABEL_API_REQUEST,
    iddealer,
    label
});

export interface ActionSearchByLabelAPISuccess extends Action {
    searchResults: SearchResults,
}

export const searchByLabelAPISuccess = (searchResults: SearchResults): ActionSearchByLabelAPISuccess => ({
    type: ACTIONS.SEARCHING_BY_LABEL_API_SUCCESS,
    searchResults
});

export const searchByLabelAPIError = (): Action => ({
    type: ACTIONS.SEARCHING_BY_LABEL_API_ERROR,
});

export interface ActionConnectDealerToEngineAPI extends Action {
    idengine?: string
    iddealer?: string
    idbusinessacount?: string
}

export const connectDealerToEngineAPI = (idengine?: string, iddealer?: string, idbusinessacount?: string): ActionConnectDealerToEngineAPI => ({
    type: ACTIONS.CONNECT_DEALER_TO_ENGINE_API_REQUEST,
    idengine,
    iddealer,
    idbusinessacount
});

export interface ActionConnectDealerToEngineAPISuccess extends Action {
    connect: Connect
}

export const connectDealerCleanState = (): ActionConnectDealerCleanState => ({
    type: ACTIONS.CONNECT_DEALER_CLEAN_STATE
});

export interface ActionConnectDealerCleanState extends Action {
}

export const connectDealerToEngineAPISuccess = (connect: Connect): ActionConnectDealerToEngineAPISuccess => ({
    type: ACTIONS.CONNECT_DEALER_TO_ENGINE_API_SUCCESS,
    connect
});

export const connectDealerToEngineAPIError = (): Action => ({
    type: ACTIONS.CONNECT_DEALER_TO_ENGINE_API_ERROR,
});



//DISCONNECT
export interface ActionDisconnectDealerToEngineAPI extends Action {
    idengine?: string
    iddealer?: string
}

export const disconnectDealerToEngineAPI = (idengine?: string, iddealer?: string): ActionDisconnectDealerToEngineAPI => ({
    type: ACTIONS.DISCONNECT_DEALER_TO_ENGINE_API_REQUEST,
    idengine,
    iddealer
});


export interface ActionDisconnectDealerToEngineAPISuccess extends Action {
    connect: Connect
}

export const disconnectDealerToEngineAPISuccess = (connect: Connect): ActionDisconnectDealerToEngineAPISuccess => ({
    type: ACTIONS.DISCONNECT_DEALER_TO_ENGINE_API_SUCCESS,
    connect
});

export const disconnectDealerToEngineAPIError = (): Action => ({
    type: ACTIONS.DISCONNECT_DEALER_TO_ENGINE_API_ERROR,
});